import React from 'react'

const Array = () => {
    return (
        <div className='container'>
            <h1>C Array</h1>
            <div className='containers'>
            An array is defined as the collection of similar type of data items stored at contiguous memory locations. Arrays are the derived data type in C programming language which can store the primitive type of data such as int, char, double, float, etc. It also has the capability to store the collection of derived data types, such as pointers, structure, etc. The array is the simplest data structure where each data element can be randomly accessed by using its index number.
<br />
C array is beneficial if you have to store similar elements. For example, if we want to store the marks of a student in 6 subjects, then we don't need to define different variables for the marks in the different subject. Instead of that, we can define an array which can store the marks in each subject at the contiguous memory locations.
<br />
By using the array, we can access the elements easily. Only a few lines of code are required to access the elements of the array. <br />

            </div>
            <h3>Properties of Array</h3>
            <div className='containers'>
                <ol>
                    <li>Each element of an array is of same data type and carries the same size, i.e., int = 4 bytes</li>
                    <li>Elements of the array are stored at contiguous memory locations where the first element is stored at the smallest memory location.</li>
                    <li>Elements of the array can be randomly accessed since we can calculate the address of each element of the array with the given base address and the size of the data element.</li>
                </ol>
            </div>
            <h3>Advantage of C Array</h3>
            <div className='containers'>
            <b>1) Code Optimization:</b> Less code to the access the data. <br />
            <b>2) Ease of traversing: </b> By using the for loop, we can retrieve the elements of an array easily. <br />
            <b>4) Random Access:</b> We can access any element randomly using the array. <br />
            </div>
            <h3>Disadvantage of C Array</h3>
            <div className='containers'>
                <b>1) Fixed Size:</b> Whatever size, we define at the time of declaration of the array, we can't exceed the limit. So, it doesn't grow the size dynamically like LinkedList which we will learn later. <br />
            </div>
            <h3>Declaration of C Array</h3>
            <div className='containers'>
            data_type array_name[array_size];  <br />
            Example: <br />
            int marks[5];  <br />
            Here, int is the data_type, marks are the array_name, and 5 is the array_size <br />
            </div>
            
        </div>
    )
}

export default Array
